import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

const ShowAlt: React.FC<IconProps> = ({ color = "#09090B", size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33333 8C8.60333 8 8 7.39667 8 6.66667C8 6.43067 8.06867 6.21133 8.17867 6.018C8.11867 6.01333 8.06133 6 8 6C7.47065 6.00349 6.96397 6.21533 6.58965 6.58965C6.21533 6.96397 6.00349 7.47065 6 8C6 9.09467 6.90533 10 8 10C9.094 10 10 9.09467 10 8C10 7.93867 9.98667 7.88133 9.982 7.82133C9.78867 7.93133 9.56933 8 9.33333 8Z"
      fill={color}
    />
    <path
      d="M8.00003 3.33331C2.91136 3.33331 1.38203 7.74465 1.36803 7.78931L1.29736 7.99998L1.36736 8.21065C1.38203 8.25531 2.91136 12.6666 8.00003 12.6666C13.0887 12.6666 14.618 8.25531 14.632 8.21065L14.7027 7.99998L14.6327 7.78931C14.618 7.74465 13.0887 3.33331 8.00003 3.33331ZM8.00003 11.3333C4.4327 11.3333 3.0507 8.76931 2.71603 7.99998C3.05203 7.22798 4.4347 4.66665 8.00003 4.66665C11.5674 4.66665 12.9494 7.23065 13.284 7.99998C12.948 8.77198 11.5654 11.3333 8.00003 11.3333Z"
      fill={color}
    />
  </svg>
);

export default ShowAlt;
